// Translations
import {
  DESCRIPTION_DESKTOP_DOWNLOAD_APP_MODAL,
  DESCRIPTION_MOBILE_DOWNLOAD_APP_MODAL,
  TITLE_DOWNLOAD_APP_MODAL,
} from '../translations/download-app-sk-modal.translations';
// Types
import {
  GetDownloadAppSKConfigurationsPropsType,
  GetDownloadAppSKConfigurationsReturnType,
} from './types/dowload-app-sk-modal.configurations.types';

export const getDownloadAppSKConfigurations = (
  props: GetDownloadAppSKConfigurationsPropsType
): GetDownloadAppSKConfigurationsReturnType => ({
  ...props,
  translations: {
    TITLE: TITLE_DOWNLOAD_APP_MODAL,
    DESCRIPTION_DESKTOP: DESCRIPTION_DESKTOP_DOWNLOAD_APP_MODAL,
    DESCRIPTION_MOBILE: DESCRIPTION_MOBILE_DOWNLOAD_APP_MODAL,
  },
});
